import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';
import { Navigation } from '~/components/common';
import { Header, MypageSubMenu } from '~/components/common/Header';
import { PAGE_ROUTE } from '~/constants';

export default function LayoutMain() {
  const location = useLocation();
  const navigate = useNavigate();

  const getTitle = (location: string) => {
    switch (location) {
      case PAGE_ROUTE.MYPAGE:
        return 'My page';
      case PAGE_ROUTE.CHAT_LIST:
        return 'Chat';
      case PAGE_ROUTE.MAIN:
        return 'Hey.D';
      case PAGE_ROUTE.ASSET:
        return 'Asset store';
      case PAGE_ROUTE.EXPLORE:
        return 'Explore';
      default:
        return '';
    }
  };

  const title = getTitle(location.pathname);
  const children = useMemo(
    () =>
      title === 'Hey.D' ? (
        <>
          <Header.Dart />
          <Button onClick={() => navigate(PAGE_ROUTE.SEARCH_ROOM)}>
            <Icon size={24} iconName='Search' />
          </Button>
        </>
      ) : title === 'My page' ? (
        <MypageSubMenu />
      ) : undefined,
    [title],
  );

  return (
    <>
      <Header.Root style={{ padding: '0 8px 0 16px' }}>
        <Header.Section>
          <Header.Title style={{ fontWeight: 700 }}>{title}</Header.Title>
        </Header.Section>
        <Header.Section>{children}</Header.Section>
      </Header.Root>
      <Outlet />
      <Navigation />
    </>
  );
}

export const Container = styled.div`
  display: block;
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 28px;
    padding: 0 12px 0 8px;
    /* border: 1px solid ${theme.content.content_light_3};
    border-radius: 14px; */
    color: ${theme.content.content_light_3};
    gap: 4px;
  `}
`;

export const Search = styled.span`
  ${({ theme }) => css`
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.body14_medium};
  `}
`;
